module.exports = __webpack_public_path__ + "img/no_data_lab.a76e3862.png";